var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShow)?_c('div',{staticClass:"course-block",on:{"click":_vm.aciton}},[_c('div',{staticClass:"course-title"},[_c('div',{staticClass:"course-title-text"},[_vm._v(_vm._s(_vm.config.text))]),_c('span')]),_c('CommonBlockLine')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }